<header class="fixed-top bg-white">
	<div
		class="pt-2 pt-lg-3 redGradient position-relative"
		style="z-index: 2"
	></div>
	<nav
		class="d-lg-flex container-xxl mx-auto bg-white position-relative"
		style="z-index: 1"
	>
		<h1 class="col-lg-2 p-0 m-0">
			<a
				class="hpLogo ms-5 ms-lg-0"
				[routerLink]="'/'"
			>
				<img
					class="w-auto"
					[src]="wcmService.logoUrl"
					alt="Homepage"
					title="Homepage"
				/>
			</a>
		</h1>

		<div
			class="mainLinks col-lg-10 bg-white text-uppercase"
			appClickOutside
			debugLabel="mainLinks"
			[class.links-open]="hamburgerOpen"
		>
			<button
				class="hamburger position-absolute d-lg-none"
				[class.hamburger-open]="hamburgerOpen"
				(click)="hamburgerOpen = !hamburgerOpen"
			>
				<span></span>
				<span></span>
				<span></span>
			</button>
		</div>
	</nav>
</header>
